import { saveAs } from "file-saver";

export interface DownloadResponse {
  filename: string;
  base64Content: string;
  path?: string;
}

export function saveFile(response: DownloadResponse) {
  if (!response?.filename || !response?.base64Content) return;

  const mime = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
  const base64StringFile = `data:${mime};base64,${response.base64Content}`;

  saveAs(base64StringFile, response.filename);
}

export function saveFileAsExcel(response: DownloadResponse) {
  if (!response?.filename || !response?.base64Content) return;

  const mime = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
  const base64StringFile = `data:${mime};base64,${response.base64Content}`;

  saveAs(base64StringFile, response.filename);
}

export function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null;
}

export function parseOutputResponse(outputResponse: string): DownloadResponse {
  try {
    const parsed = JSON.parse(outputResponse) as unknown;
    if (!isRecord(parsed)) {
      return { filename: "download.docx", base64Content: "", path: outputResponse };
    }
    return {
      filename: typeof parsed.filename === "string" ? parsed.filename : "download.docx",
      base64Content: typeof parsed.base64Content === "string" ? parsed.base64Content : "",
      path: typeof parsed.path === "string" ? parsed.path : outputResponse,
    };
  } catch {
    return {
      filename: "download.docx",
      base64Content: "",
      path: outputResponse,
    };
  }
}
